import data from '../data'
import requestToBOAction from './requestToBO.action'
import { storageActionGet } from './storage.action'

const addItemsToCustomerMeta = (itemsArr, customerId, email) => {
  for (const { sku } of itemsArr) {
    requestToBOAction('ADD', {
      sku,
      customer_id: customerId,
      email
    })
  }
}

const getProductsAction = async () => {
  const handlesFromMeta = window.customer.wishlistItemHandles
    ? window.customer.wishlistItemHandles.split('|')
    : []

  if (data.customerId) {
    data.products = storageActionGet().filter(item => {
      return !(item.deletedFromMeta && !handlesFromMeta.includes(item.handle))
    })

    const itemsArrForMeta = data.products.filter(item => {
      if (
        !handlesFromMeta.includes(item.handle) &&
        !item.addedToMeta &&
        !item.deletedFromMeta
      ) {
        item.addedToMeta = true
        return true
      }
      return false
    })

    addItemsToCustomerMeta(itemsArrForMeta, data.customerId, data.customerEmail)
  } else {
    data.products = storageActionGet().filter(elem => !elem.deletedFromMeta)
  }

  if (handlesFromMeta.length) {
    const handlesFromLocale = data.products.map(i => i.handle)
    const newHandles = handlesFromMeta.filter(h => !handlesFromLocale.includes(h))

    await Promise.all(newHandles.map(async handle => {
      return await window.fetch(`/products/${handle}.js`)
        .then(async response => {
          if (response.ok) {
            const product = await response.json()
            data.products.push({
              id: product.id,
              title: product.title,
              handle: product.handle,
              image: product.featured_image,
              sku: product.variants[0].sku,
              url: product.url,
              addedToMeta: !!data.customerId,
              deletedFromMeta: false
            })
            return true
          }
          return false
        })
        .catch(e => {
          console.log(e)
          return false
        })
    }))
  }
}

export default getProductsAction
